/**
 * Created by: Lior Elrom
 * Date: 12/1/15
 * Time: 10:32 AM
 */

'use strict';

var SoaModel = require('bunsen/models/SoaModel');
var InvoiceItem = SoaModel.extend();

var _ = require('underscore');
var Backbone = require('dibs-backbone');
var financialAmountMixin = require('bunsen/models/mixins/financialAmountMixin');
var FinancialAmount = require('bunsen/models/FinancialAmount');

_.extend(InvoiceItem.prototype, {
    relations: [
        {
            type: Backbone.One,
            key: 'subTotalAmount',
            relatedModel: FinancialAmount
        },
        {
            type: Backbone.One,
            key: 'totalAmount',
            relatedModel: FinancialAmount
        }
    ]
}, financialAmountMixin);

module.exports = InvoiceItem;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/InvoiceItem.js
// module id = 173
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54